import { clearingApi } from "../../config/apiConfig";

export const getClearingEMPs = async () => {
  try {
    const response = await clearingApi.get(`emps`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getNewEMPs = async () => {
  const edpoint = "cdrs/sync-new-emps";

  try {
    const response = await clearingApi.get(edpoint);

    if (response?.status >= 300) {
      return false;
    }

    return response?.data || true;
  } catch (error) {
    console.error(error);

    return false;
  }
};

export const addEMP = async (data) => {
  const requestBody = [{ ...data, email: [data?.email] }];

  try {
    const response = await clearingApi.post(`emps`, requestBody);

    if (response?.status >= 300) {
      console.log("Add Emp response", response);
      return false;
    }

    return true;
  } catch (e) {
    console.error("Failed to add EMP.", e);
    return false;
  }
};

export const updateEMPDetails = async (id, data) => {
  try {
    data = {
      ...data,
      email: [data?.email], // required format for backend: {..., email: ['string']}
    };
    const response = await clearingApi.put(`emps/${id}`, data);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteEMPById = async (id) => {
  if (!id || id === "") {
    console.error(
      "Failed to delete EMP because no EMP ID was provided; \n id:",
      id
    );

    return false;
  }

  try {
    const response = await clearingApi.delete(`/backoffice/emps/${id}`);

    if (response?.status > 300) {
      console.error("Delete EMP response not ok:", response);
      return false;
    }

    return true;
  } catch (error) {
    console.error("Failed to delete EMP by ID", error);
    return false;
  }
};
